import React from "react";

const ProjectTitleCard = ({
  title,
  count,
  icon,
  textColor,
  bgColor,
  onClickCard,
}) => {
  return (
    <div className="bg-white rounded-xl shadow p-6 flex justify-between items-start cursor-pointer">
      <div className="space-y-1">
        <p
          className={`font-medium font-Inter text-[16px] font-[700] leading-[20px] ${!textColor ? "text-gray-500" : ""}`}
          style={textColor ? { color: textColor } : undefined}
        >
          {title}
        </p>
        <h2 className={`text-[32px] font-[700] leading-[40px]`}>{count}</h2>
      </div>
      <div
        // Tailwind's className parser does not allow arbitrary color hex values directly like bg-[#197DCAFF]
        // Use style prop for dynamic backgroundColor instead:
        className="p-3 rounded-full"
        style={
          bgColor
            ? { backgroundColor: bgColor }
            : { backgroundColor: "#E5E7EB" }
        } // #E5E7EB is Tailwind's bg-gray-200
      >
        {icon}
      </div>
    </div>
  );
};

export default ProjectTitleCard;
